import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, Loader2, User, Coins, ExternalLink } from "lucide-react";
import { adminApi } from "../../api/auth";
import { Input } from "../../components/ui/input";

const MET = { paypal: "PayPal", mp_ar: "MP-AR", mp_cl: "MP-CL", khipu: "Khipu", crypto: "USDT" };

export default function AdminSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [searched, setSearched] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (q.trim().length < 2) { setErr("Minimo 2 caracteres"); return; }
    setLoading(true); setErr(""); setSearched(true);
    try {
      const data = await adminApi.search(q.trim());
      setResults(data.results || []);
    } catch (e) { setErr(e.message); setResults([]); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-5" data-testid="admin-search">
      <div>
        <div className="ornament"><span>Buscar Player</span></div>
        <h1 className="section-title mt-3 text-3xl">Buscar jugador / cuenta</h1>
        <p className="text-sm text-[#b8b3a8] mt-2">Busca por account, nombre de personaje, email, order UID o IP.</p>
      </div>

      <form onSubmit={onSubmit} className="flex gap-2">
        <Input type="text" placeholder="ej: alone, juan@email.com, ORD-..., 1.2.3.4"
          value={q} onChange={(e) => setQ(e.target.value)}
          className="bg-[#15110a] border-[#3a3328] text-white"
          data-testid="search-input" autoFocus />
        <button type="submit" disabled={loading}
          className="px-4 py-2 bg-[#d4a843] text-black text-sm rounded font-medium hover:bg-[#e0b860] disabled:opacity-50"
          data-testid="search-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
        </button>
      </form>

      {err && <div className="text-red-400 text-sm border border-red-900/40 p-3 rounded">{err}</div>}

      {searched && !loading && results.length === 0 && !err && (
        <div className="text-[#7e7768] text-sm text-center py-8 border border-[#3a3328] rounded">No se encontraron resultados</div>
      )}

      <div className="space-y-3" data-testid="search-results">
        {results.map((r) => (
          <Link key={r.account} to={`/admin/player/${encodeURIComponent(r.account)}`}
            className="block border border-[#3a3328] bg-[#15110a]/70 rounded-lg p-4 hover:border-[#d4a843]/40 transition">
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <User className="w-4 h-4 text-[#d4a843]" />
                  <span className="text-white font-medium text-lg">{r.account}</span>
                  {r.access_level >= 100 && (
                    <span className="text-[10px] uppercase bg-purple-900/40 text-purple-300 px-2 py-0.5 rounded">GM lvl {r.access_level}</span>
                  )}
                  <ExternalLink className="w-3.5 h-3.5 text-[#7e7768]" />
                </div>
                <div className="text-xs text-[#7e7768] mt-1">
                  Last IP: {r.last_ip || "—"} · Personajes: {r.characters.length}
                </div>
                {r.characters.length > 0 && (
                  <div className="text-xs text-[#b8b3a8] mt-2 flex flex-wrap gap-x-3 gap-y-1">
                    {r.characters.slice(0, 5).map((c) => (
                      <span key={c.name}>
                        <span className="text-white">{c.name}</span> <span className="text-[#7e7768]">[{c.class} lvl {c.level}]</span>
                      </span>
                    ))}
                    {r.characters.length > 5 && <span className="text-[#7e7768]">+{r.characters.length - 5} mas</span>}
                  </div>
                )}
              </div>
              <div className="text-right">
                <div className="flex items-center gap-1.5 text-amber-300 text-lg">
                  <Coins className="w-4 h-4" />
                  {Number(r.donations.coins).toLocaleString()}
                </div>
                <div className="text-xs text-[#7e7768]">
                  {r.donations.orders_approved} aprobadas / {r.donations.orders_total} total
                </div>
                {r.donations.by_method.length > 0 && (
                  <div className="text-[10px] text-[#b8b3a8] mt-1 uppercase tracking-wider">
                    {r.donations.by_method.map((m) => (
                      <span key={m.method + m.currency} className="ml-2">
                        {MET[m.method]} {Number(m.total).toLocaleString()} {m.currency}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
